import {initAlgolytics} from "@pg-mono/algolytics";
import {
    cleanAmplitudeParamsFromUrl,
    getRedirectUrlWithTopLevelAmpParams,
    IAmplitudeExperimentVariants,
    initAmplitude,
    initAmplitudeCrossDomainTracking,
    resolveFeatureFlags,
    setResolvedFeatureFlags,
    waitForAmplitudeInitialization
} from "@pg-mono/amplitude";
import {GoogleMapsApiConfig} from "@pg-mono/google-api";
import {getRedirectUrlWithTopLevelCookieConsent, getRedirectUrlWithTopLevelGl} from "@pg-mono/google-tag-manager";
import {setDefaultOptions as setOSMDefaultOptions} from "@pg-mono/open-street-map";
import {initUserCom} from "@pg-mono/user-com";

import {kmFeatureFlags} from "../../common/feature_flags/km_feature_flags";
import {GOOGLE_API_KEY} from "../../features/km_app/constants/keys";
import {
    algolyticsId,
    amplitudeApiKey,
    amplitudeDeploymentKey,
    amplitudeEnvironment,
    osmTileUrl,
    rpRedirectUrl,
    showAlgolyticsLogs,
    userComAppSubdomain,
    userComId
} from "../../features/km_app/utils/read_environment_variables";
import {initGoogleMap} from "../../features/map/utils/init_google_map";
import {configureGoogleTagManager, initGoogleTagManager} from "../../features/tracking/gtm/init_gtm";
import {initKmDevtools} from "../init_km_devtools";
import {startMockServiceWorker} from "./mock_service_worker";

declare global {
    interface Window {
        __AMPLITUDE_VARIANTS__?: IAmplitudeExperimentVariants;
    }
}

const bootstrapFeatureFlagsFromInitialVariants = (): IAmplitudeExperimentVariants | undefined => {
    const initialVariants = window.__AMPLITUDE_VARIANTS__;
    delete window.__AMPLITUDE_VARIANTS__;

    setResolvedFeatureFlags(resolveFeatureFlags(kmFeatureFlags, initialVariants ?? {}));

    return initialVariants;
};

export const initClientApp = () => async (renderApp: () => void) => {
    const currentUrl = window.location.href;
    const afterCookieConsent = getRedirectUrlWithTopLevelCookieConsent(currentUrl) ?? currentUrl;
    const afterGl = getRedirectUrlWithTopLevelGl(afterCookieConsent) ?? afterCookieConsent;
    const afterAmp = getRedirectUrlWithTopLevelAmpParams(afterGl) ?? afterGl;

    if (afterAmp !== currentUrl) {
        window.location.replace(afterAmp);
        return;
    }

    initGoogleMap();

    if (osmTileUrl) {
        setOSMDefaultOptions({
            tileUrl: osmTileUrl,
            tileSize: 256,
            tileCrossOrigin: false,
            defaultMinZoom: 7
        });
    }

    await startMockServiceWorker();

    GoogleMapsApiConfig.setApiKey(GOOGLE_API_KEY);
    const initialVariants = bootstrapFeatureFlagsFromInitialVariants();

    initUserCom({userComId, userComAppSubdomain});
    initAlgolytics(algolyticsId, showAlgolyticsLogs, "www_events_km");

    initAmplitude({
        amplitudeApiKey,
        environment: amplitudeEnvironment,
        deploymentKey: amplitudeDeploymentKey,
        initialVariants,
        isBrowser: true
    });

    if (rpRedirectUrl) {
        initAmplitudeCrossDomainTracking([new URL(rpRedirectUrl).hostname]);
    }
    void waitForAmplitudeInitialization().then(() => cleanAmplitudeParamsFromUrl());

    configureGoogleTagManager({viewType: "Konto Mieszkaniowe"});
    initGoogleTagManager();

    initKmDevtools();

    renderApp();
};
import {initAlgolytics} from "@pg-mono/algolytics";
import {
    cleanAmplitudeParamsFromUrl,
    getRedirectUrlWithTopLevelAmpParams,
    IAmplitudeExperimentVariants,
    initAmplitude,
    initAmplitudeCrossDomainTracking,
    resolveFeatureFlags,
    setResolvedFeatureFlags,
    waitForAmplitudeInitialization
} from "@pg-mono/amplitude";
import {GoogleMapsApiConfig} from "@pg-mono/google-api";
import {getRedirectUrlWithTopLevelCookieConsent, getRedirectUrlWithTopLevelGl} from "@pg-mono/google-tag-manager";
import {setDefaultOptions as setOSMDefaultOptions} from "@pg-mono/open-street-map";
import {initUserCom} from "@pg-mono/user-com";

import {kmFeatureFlags} from "../../common/feature_flags/km_feature_flags";
import {GOOGLE_API_KEY} from "../../features/km_app/constants/keys";
import {
    algolyticsId,
    amplitudeApiKey,
    amplitudeDeploymentKey,
    amplitudeEnvironment,
    osmTileUrl,
    rpRedirectUrl,
    showAlgolyticsLogs,
    userComAppSubdomain,
    userComId
} from "../../features/km_app/utils/read_environment_variables";
import {initGoogleMap} from "../../features/map/utils/init_google_map";
import {configureGoogleTagManager, initGoogleTagManager} from "../../features/tracking/gtm/init_gtm";
import {initKmDevtools} from "../init_km_devtools";
import {startMockServiceWorker} from "./mock_service_worker";

declare global {
    interface Window {
        __AMPLITUDE_VARIANTS__?: IAmplitudeExperimentVariants;
    }
}

const bootstrapFeatureFlagsFromInitialVariants = (): IAmplitudeExperimentVariants | undefined => {
    const initialVariants = window.__AMPLITUDE_VARIANTS__;
    delete window.__AMPLITUDE_VARIANTS__;

    setResolvedFeatureFlags(resolveFeatureFlags(kmFeatureFlags, initialVariants ?? {}));

    return initialVariants;
};

export const initClientApp = () => async (renderApp: () => void) => {
    const currentUrl = window.location.href;
    const afterCookieConsent = getRedirectUrlWithTopLevelCookieConsent(currentUrl) ?? currentUrl;
    const afterGl = getRedirectUrlWithTopLevelGl(afterCookieConsent) ?? afterCookieConsent;
    const afterAmp = getRedirectUrlWithTopLevelAmpParams(afterGl) ?? afterGl;

    if (afterAmp !== currentUrl) {
        window.location.replace(afterAmp);
        return;
    }

    initGoogleMap();

    if (osmTileUrl) {
        setOSMDefaultOptions({
            tileUrl: osmTileUrl,
            tileSize: 256,
            tileCrossOrigin: false,
            defaultMinZoom: 7
        });
    }

    await startMockServiceWorker();

    GoogleMapsApiConfig.setApiKey(GOOGLE_API_KEY);
    const initialVariants = bootstrapFeatureFlagsFromInitialVariants();

    initUserCom({userComId, userComAppSubdomain});
    initAlgolytics(algolyticsId, showAlgolyticsLogs, "www_events_km");

    initAmplitude({
        amplitudeApiKey,
        environment: amplitudeEnvironment,
        deploymentKey: amplitudeDeploymentKey,
        initialVariants,
        isBrowser: true
    });

    if (rpRedirectUrl) {
        initAmplitudeCrossDomainTracking([new URL(rpRedirectUrl).hostname]);
    }
    void waitForAmplitudeInitialization().then(() => cleanAmplitudeParamsFromUrl());

    configureGoogleTagManager({viewType: "Konto Mieszkaniowe"});
    initGoogleTagManager();

    initKmDevtools();

    renderApp();
};
